import styled from "styled-components";

export const ContactWrapper = styled.div`
// border:1px solid red;
  margin-top: -5rem;
`;

export const Image = styled.img`
//border:1px solid red;
  width: 350px;
  margin: 0 auto;
  margin-bottom: 2rem;
`;
export const Card=styled.div`
`
export const Technologies = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: -2rem;
`;

export const Tech = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100px;
  min-width: 100px;
  margin-bottom: 2rem;
`;

export const TechImg = styled.img`
  height: 50px;
  width: 50px;
`;

export const TechName = styled.div`
  font-size: 14px;
`;
